module.exports = __webpack_public_path__ + "img/banner2.89d90b7d.jpg";